// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GameKey } from '@site-builder/store-sdk';
import cn from 'classnames';
import React from 'react';

import type { IPriceForStoreItem } from '../../../../types/store/store-item-price';

import VirtualPrice from './VirtualPrice';
import './style.pcss';

interface IStorePriceProps {
  price: IPriceForStoreItem;
  className?: string;
}

const StorePrice: React.FC<IStorePriceProps> = ({ price, className }) => {
  const { vcPrice, isForVc, realPrice, realWithoutDiscountPrice, hasDiscount } =
    price;
  return (
    <div
      className={cn('store__price-block', className)}
      data-type='price-block'
    >
      {isForVc ? (
        <div className='store__price-virtual-block' key={vcPrice?.sku}>
          <span className='store__price-with-discount'>
            <VirtualPrice amount={vcPrice?.amount} img={vcPrice?.image_url} />
          </span>
          {hasDiscount && (
            <span className='store__price-without-discount'>
              <VirtualPrice
                amount={vcPrice?.amount_without_discount}
                img={vcPrice?.image_url}
                withoutDiscount
              />
            </span>
          )}
        </div>
      ) : (
        realPrice && (
          <div className='store__price-real'>
            <span className='store__price-with-discount'>{realPrice}</span>
            {hasDiscount && (
              <span className='store__price-without-discount'>
                {realWithoutDiscountPrice}
              </span>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default StorePrice;
